import { z } from 'zod';

const moneyDto = z.object({
  amount: z.number(),
  currency: z.enum(['GEL', 'USD', 'EUR']),
});

const imageDto = z.object({
  url: z.string().url(),
  alt: z.string().default(''),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
});

const wishlistItemDto = z.object({
  product_id: z.union([z.string(), z.number()]).transform(String),
  sku: z.string(),
  slug: z.string(),
  title: z.string(),
  image: imageDto.nullable().default(null),
  price: moneyDto,
  compare_at_price: moneyDto.nullable().default(null),
  in_stock: z.boolean(),
  added_at: z.string(),
});

export const wishlistDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  items: z.array(wishlistItemDto).default([]),
  item_count: z.number().int().min(0).default(0),
  updated_at: z.string(),
});

export type WishlistDto = z.infer<typeof wishlistDto>;
export type WishlistItemDto = z.infer<typeof wishlistItemDto>;
